import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../Config";

const useTenantDetailsModal = ({
    tenants = [],
    token,
}) => {
    const [selectedIndex, setSelectedIndex] =
        useState(null);

    const [selectedTenant, setSelectedTenant] =
        useState(null);

    const [showTenantModal, setShowTenantModal] =
        useState(false);

    const fetchTenantDetails = async (
        tenantId
    ) => {
        const response = await axios.get(
            `${Config.apiUrl}/tenant/details/${tenantId}`,
            {
                headers: {
                    authorization: `Bearer ${token}`,
                    "Content-Type":
                        "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );

        return response.data;
    };

    const {
        mutate: getTenantDetails,
        isLoading,
    } = useMutation(fetchTenantDetails, {
        onSuccess: (res) => {
            if (res?.data === false) return;

            setSelectedTenant(res?.data);

            //setShowTenantModal(true);
        },
    });

    useEffect(() => {
        if (
            selectedIndex === null ||
            !tenants?.[selectedIndex]
        ) {
            return;
        }

        const tenantId =
            tenants[selectedIndex]?.tenantId;

        if (tenantId) {
            getTenantDetails(tenantId);
        }
    }, [selectedIndex]);

    const openTenantModal = (tenantOrId) => {

        const tenantId =
            typeof tenantOrId === "object"
                ? tenantOrId?.tenantId
                : tenantOrId;
        const index = tenants.findIndex(
            (item) => Number(item.tenantId) === Number(tenantId)
        );

        if (index === -1) {
            console.error(
                "Tenant not found",
                tenantId
            );
            return;
        }
        setShowTenantModal(true);
        setSelectedTenant(null);
        setSelectedIndex(index);
    };

    const handleNext = () => {
        if (selectedIndex < tenants.length - 1) {
            setSelectedIndex((prev) => prev + 1);
        }
    };

    const handlePrevious = () => {
        if (selectedIndex > 0) {
            setSelectedIndex((prev) => prev - 1);
        }
    };

    const closeTenantModal = () => {
        setShowTenantModal(false);
        setSelectedIndex(null);
        setSelectedTenant(null);
    };

    return {
        selectedTenant,
        showTenantModal,
        openTenantModal,
        closeTenantModal,
        handleNext,
        handlePrevious,
        hasNext:
            selectedIndex !== null &&
            selectedIndex < tenants.length - 1,

        hasPrevious:
            selectedIndex !== null &&
            selectedIndex > 0,

        isLoading,
    };
};

export default useTenantDetailsModal;